import React, { createContext, useContext, useState } from "react";
import { getLang, setLang } from "./index";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getLang());
  const change = (code) => {
    setLang(code);
    setLangState(code);
  };
  return (
    <LangContext.Provider value={{ lang, setLang: change }}>
      <React.Fragment key={lang}>{children}</React.Fragment>
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
